import { ArrowUp, ArrowDown, Trash2, Plus, X } from "lucide-react";
import { Button } from "@/components/kit";
import PhotoCapture, { AuthImage } from "@/components/conference/PhotoCapture";

export function StepsEditor({ steps, setSteps }) {
  const set = (i, v) => setSteps(steps.map((s, j) => (j === i ? { ...s, text: v } : s)));
  const move = (i, d) => {
    const n = [...steps];
    [n[i], n[i + d]] = [n[i + d], n[i]];
    setSteps(n);
  };
  return (
    <div className="flex flex-col gap-3" data-testid="steps-editor">
      {steps.map((s, i) => (
        <div key={s.key} className="flex gap-3 items-start" data-testid={`step-${i}`}>
          <div className="w-8 h-8 rounded-full flex items-center justify-center text-white text-sm font-bold shrink-0 mt-1" style={{ background: "var(--brand)" }}>{i + 1}</div>
          <textarea className="input flex-1" rows={2} placeholder={`Descreva a etapa ${i + 1}`} value={s.text} onChange={(e) => set(i, e.target.value)} data-testid={`step-input-${i}`} />
          <div className="flex flex-col gap-1">
            <button type="button" className="icon-btn !w-8 !h-8" disabled={i === 0} onClick={() => move(i, -1)} data-testid={`step-up-${i}`}><ArrowUp size={14} /></button>
            <button type="button" className="icon-btn !w-8 !h-8" disabled={i === steps.length - 1} onClick={() => move(i, 1)} data-testid={`step-down-${i}`}><ArrowDown size={14} /></button>
            <button type="button" className="icon-btn !w-8 !h-8" onClick={() => setSteps(steps.filter((_, j) => j !== i))} data-testid={`step-remove-${i}`}><Trash2 size={14} /></button>
          </div>
        </div>
      ))}
      <Button variant="secondary" size="sm" icon={Plus} className="self-start" onClick={() => setSteps([...steps, { key: crypto.randomUUID(), text: "" }])} data-testid="add-step-button">Adicionar etapa</Button>
    </div>
  );
}

export function PhotoField({ label, path, onChange, testid }) {
  return (
    <div className="flex flex-col gap-2" data-testid={testid}>
      <span className="label">{label}</span>
      {path ? (
        <div className="relative w-full max-w-sm">
          <AuthImage path={path} className="w-full aspect-[4/3] rounded-xl" testid={`${testid}-preview`} />
          <button type="button" className="icon-btn absolute top-2 right-2 shadow" onClick={() => onChange(null)} data-testid={`${testid}-remove`}><X size={15} /></button>
        </div>
      ) : (
        <PhotoCapture onUploaded={onChange} cameraLabel="Tirar foto" />
      )}
    </div>
  );
}
